import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="min-h-screen flex items-center justify-center relative overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.8), rgba(30, 27, 75, 0.8)), url('https://public.readdy.ai/ai/img_res/cda733a1719c896fb8b420a0188faf13.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 to-violet-900/20"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="w-full">
          <h2 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Empowering Growth Through{' '}
            <span className="bg-gradient-to-r from-blue-400 to-violet-400 bg-clip-text text-transparent">
              Knowledge, Technology & Decentralization
            </span>
          </h2>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-4xl mx-auto leading-relaxed">
            Transform your business with our comprehensive solutions combining expert consulting, 
            cutting-edge digital innovation, and decentralized infrastructure for sustainable growth.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              onClick={scrollToContact}
              size="lg"
              className="min-w-[200px]"
            >
              <i className="ri-rocket-line mr-2"></i>
              Get Started Today
            </Button>
            <Button 
              onClick={scrollToServices}
              variant="outline"
              size="lg"
              className="min-w-[200px]"
            >
              <i className="ri-eye-line mr-2"></i>
              Explore Services
            </Button>
          </div>
          
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center border-2 border-blue-400 rounded-full mx-auto mb-4 bg-transparent">
                <i className="ri-lightbulb-line text-2xl text-blue-400"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">Expert Consulting</h3>
              <p className="text-gray-400">Strategic business guidance and trading psychology expertise</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center border-2 border-violet-400 rounded-full mx-auto mb-4 bg-transparent">
                <i className="ri-computer-line text-2xl text-violet-400"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">Digital Innovation</h3>
              <p className="text-gray-400">Cloud solutions, VPS hosting, and secure storage systems</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center border-2 border-blue-400 rounded-full mx-auto mb-4 bg-transparent">
                <i className="ri-links-line text-2xl text-blue-400"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">Decentralized Infrastructure</h3>
              <p className="text-gray-400">Blockchain networks, VPN services, and node management</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-gray-400"></i>
      </div>
    </section>
  );
}
